module.exports = __webpack_public_path__ + "img/Stylized Sword-Basic.6fe2d58c.png";